import React from "react";
import StatusChip from "./StatusChip";

interface Props {
  isStarted: boolean;
  isCompleted?: boolean;
}

// Three-state shipping chip:
//   - nothing started yet → Pending
//   - Arta shipment created, still in transit → In transit
//   - Arta shipment reached "completed" → Delivered
//
// Completion takes precedence over started so the row reflects the latest
// state Arta gave us (both flags are set simultaneously once a shipment
// is delivered).
const ShippingStatusChip: React.FC<Props> = ({ isStarted, isCompleted }) => {
  if (isCompleted) {
    return <StatusChip tone="success" icon="bi-box-seam" label="Delivered" />;
  }
  if (isStarted) {
    return <StatusChip tone="primary" icon="bi-truck" label="In transit" />;
  }
  return <StatusChip tone="danger" icon="bi-hourglass-split" label="Pending" />;
};

export default ShippingStatusChip;
